module.exports = __webpack_public_path__ + "static/media/relationship-between-banner2.aab7eb4a.png";